import { render } from "./create_sections.html?vue&type=template&id=41da62c6&external"
import script from "./create_sections.js?vue&type=script&lang=js&external"
export * from "./create_sections.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__